import useTranslation from "next-translate/useTranslation";
import style from "./style.module.css";
import Portabletext from "sanity/portabletext";
import { serializer } from "SanityComponents/GuideDuCredit/GuidePosts";
import PortableText from "@sanity/block-content-to-react";
import DropdownBodyContent from "SanityComponents/GuideDuCredit/DropdownBodyContent";

function ArticleInsideListingList({ articleData }: { articleData?: any }) {
  const { t, lang } = useTranslation("villesprovincescommunes");

  return (
    <div className={style.article__container}>
      <div className={style.quote__container}>
        <div className={style.quote__inner}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="16"
            viewBox="0 0 22 16"
            fill="none"
          >
            <path
              d="M0 6C0 2.685 2.63705 0 5.89286 0H6.28571C7.15491 0 7.85714 0.715 7.85714 1.6C7.85714 2.485 7.15491 3.2 6.28571 3.2H5.89286C4.37545 3.2 3.14286 4.455 3.14286 6V6.4H6.28571C8.0192 6.4 9.42857 7.835 9.42857 9.6V12.8C9.42857 14.565 8.0192 16 6.28571 16H3.14286C1.40937 16 0 14.565 0 12.8V11.2V9.6V6ZM12.5714 6C12.5714 2.685 15.2085 0 18.4643 0H18.8571C19.7263 0 20.4286 0.715 20.4286 1.6C20.4286 2.485 19.7263 3.2 18.8571 3.2H18.4643C16.9469 3.2 15.7143 4.455 15.7143 6V6.4H18.8571C20.5906 6.4 22 7.835 22 9.6V12.8C22 14.565 20.5906 16 18.8571 16H15.7143C13.9808 16 12.5714 14.565 12.5714 12.8V11.2V9.6V6Z"
              fill="black"
            />
          </svg>
        </div>
      </div>
      <div className={style.text__container}>
        {articleData?.contents?.map((item, index) => {
          return (
            <>
              {item.texte?.length > 0 && (
                <>
                  {item.texte.map((e, index) => {
                    return (
                      <>
                        {lang == "ar"
                          ? e?.article?.texte_ar && (
                              <PortableText
                                projectId="n2i0cmq4"
                                dataset="production"
                                blocks={e.article.texte_ar}
                                serializers={serializer}
                              />
                            )
                          : e?.article?.texte_fr && (
                              <PortableText
                                projectId="n2i0cmq4"
                                dataset="production"
                                blocks={e.article.texte_fr}
                                serializers={serializer}
                              />
                            )}

                        {e._type == "Faq" && (
                          <DropdownBodyContent
                            title={e.titre ? e.titre[lang] : null}
                            items={e.faq}
                            lang={lang}
                          />
                        )}

                        {lang == "ar"
                          ? e?.plus_article?.body2_texte_ar && (
                              <PortableText
                                projectId="n2i0cmq4"
                                dataset="production"
                                blocks={e.plus_article.body2_texte_ar}
                                serializers={serializer}
                              />
                            )
                          : e?.plus_article?.body2_texte_fr && (
                              <PortableText
                                projectId="n2i0cmq4"
                                dataset="production"
                                blocks={e.plus_article.body2_texte_fr}
                                serializers={serializer}
                              />
                            )}
                      </>
                    );
                  })}
                </>
              )}
            </>
          );
        })}
      </div>
    </div>
  );
}

export default ArticleInsideListingList;
